import { useEffect, useState } from 'react';
import { OnboardingEye } from '../Eye';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { SequenceItem } from './OnboardingSequence';
import InputBar from '../InputBar';
import BPInput from '../../BionicUI/input/BPInput';
import useOnboardingStore from 'stores/onboardingStore';
import { PostUserProfileRequest } from 'core/models/users/profile/post-user-profile.model';
import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
// import { useAuth } from 'context/auth.context';
import useNotifyStore from 'stores/notifyStore';
import BPToast from 'components/BionicUI/toast/BPToast';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes';
import { getAccessToken, usePrivy } from '@privy-io/react-auth';
import axios from 'axios';
import { privyAppId } from 'App';
import { jwtDecode } from 'jwt-decode';

const FullName = () => {
  const [showInputBar, setShowInputBar] = useState<boolean>(false);
  const { nextStep } = useOnboardingStore();
  const navigate = useNavigate();

  const { user } = usePrivy();
  const { setCurrentToast } = useNotifyStore();

  async function handleSubmit(inputText: string | null | undefined) {
    if (!inputText) return;

    try {
      const request: PostUserProfileRequest = {
        displayName: inputText,
      };
      await new UserV1BaseServerRepo().createProfile(request);
      nextStep();
    } catch (err: any) {
      const errMsg = err.response?.data?.message || 'Try again later.';
      setCurrentToast(
        <BPToast message="Failed" description={errMsg} variant="error" />
      );
    }
  }

  useEffect(() => {
    if (user) {
      const privyIdToken = localStorage.getItem('privy:id_token');
      if (privyIdToken) {
        const decoded: any = jwtDecode(privyIdToken);
        const roles = decoded?.custom_metadata
          ? JSON.parse(decoded?.custom_metadata)?.roles || []
          : [];
        if (roles.length === 0) {
          refreshToken();
        }
      }
    }
  }, [user]);

  async function refreshToken() {
    try {
      const token = await getAccessToken();
      if (token) {
        const refreshToken = localStorage.getItem('privy:refresh_token');

        const response = await axios.post(
          'https://auth.privy.io/api/v1/sessions',
          { refresh_token: refreshToken ? JSON.parse(refreshToken) : '' },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'privy-app-id': privyAppId,
            },
            withCredentials: true,
          }
        );
        if (response.status === 200) {
          localStorage.setItem(
            'privy:id_token',
            JSON.stringify(response.data.identity_token)
          );
        }
      }
    } catch (error) {
      console.log('Error--', error);
    }
  }

  useEffect(() => {
    setTimeout(() => setShowInputBar(true), 350);
  }, []);

  return (
    <SequenceItem>
      <div className="flex justify-center w-full max-w-[800px] px-6 gap-[20px] mx-auto items-start">
        <OnboardingEye />
        <BPInstruction
          line1={{
            text: 'Now enter your full name...',
            sound: 'step1/now-enter-your-full-name.mp3',
          }}
        />
      </div>
      {showInputBar && (
        <InputBar onClickBackButton={() => navigate(ROUTES.LANDING)}>
          <BPInput
            state="default"
            type="text"
            placeholder="Enter your full name"
            button={{
              state: 'primary',
              onClick: (e, inputText) => handleSubmit(inputText),
              title: 'Submit',
            }}
            validate={(text) => text.length > 3}
          />
        </InputBar>
      )}
    </SequenceItem>
  );
};

export default FullName;
